// @flow
import * as React from 'react';

import { defaultTheme } from '@sonyged/proc-ui';
import Star from '!!svg-react-loader!../../../../assets/images/pages/pizza/fields/star.svg';
import css from '@styled-system/css';
import styled from 'styled-components';

export class Stars extends React.PureComponent<{ stars: number }> {
  render() {
    let stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= this.props.stars) {
        stars.push(<Star key={`full-${i}`} className="star full" />);
      } else if (i === this.props.stars + 0.5) {
        stars.push(<Star key={`half`} className="star half" />);
      } else {
        stars.push(<Star key={`empty-${i}`} className="star empty" />);
      }
    }

    return <Span>{stars}</Span>;
  }
}

const Span = styled('span')(
  css({
    '.star': {
      size: [18, 18, 24],
      mr: ['4px', '4px', '6px'],
      // iPhone SE
      '@media screen and (max-width: 360px)': {
        size: 14,
      },
    },
  })
);
Span.defaultProps = { theme: defaultTheme };
